import { Component } from '@angular/core';
import { InviteWorkerRequest }  from '../../models/invite-worker-request.model';
import { InviteWorkerResponse } from '../../models/invite-worker-response.model';
import { UserService }          from '../../services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector:    'app-invite-worker',
  templateUrl: './invite-worker.component.html',
  styleUrls:   ['./invite-worker.component.css']
})
export class InviteWorkerComponent {

  model: InviteWorkerRequest = {
    fullName: '',
    email:    '',
    role:     'Worker'          // ✅ default
  };

  loading        = false;
  success: InviteWorkerResponse | null = null;
  error:   string | null = null;
  copied         = false;
  upgradeMessage = '';

  constructor(private userService: UserService) {}

  // ✅ Role options shown in the selector
  roles = [
    {
      value:       'Worker' as const,
      label:       'Field Worker',
      description: 'Uses the mobile app. Can view assigned jobs and permits, submit work logs, and accept permits.',
      icon:        '👷'
    },
    {
      value:       'Admin' as const,
      label:       'Admin / Supervisor',
      description: 'Uses the web dashboard. Can create permits, approve permits created by others, manage jobs, and view reports.',
      icon:        '🏢'
    }
  ];

  selectRole(role: 'Worker' | 'Admin'): void {
    this.model.role = role;
  }

  invite(): void {
    if (!this.model.fullName.trim() || !this.model.email.trim()) return;

    this.loading = true;
    this.error   = null;
    this.success = null;

    this.userService.inviteWorker(this.model).subscribe({

      next: (response: InviteWorkerResponse) => {
        this.success        = response;
        this.loading        = false;
        this.upgradeMessage = '';
        this.model          = { fullName: '', email: '', role: 'Worker' };
      },

      error: (err) => {
        if (err?.error?.upgradeRequired) {
          this.upgradeMessage = err.error.message;
          this.error          = null;
          Swal.fire({
            title:             'Worker Limit Reached',
            html:              `<p style="color:#374151;font-size:14px">${err.error.message}</p>`,
            icon:              'warning',
            confirmButtonText: 'View Pricing',
            showCancelButton:  true,
            cancelButtonText:  'Cancel',
            confirmButtonColor: '#2BB0A6',
            cancelButtonColor:  '#6B7280',
            customClass: { popup: 'swal-fieldops' }
          }).then(result => {
            if (result.isConfirmed) window.location.href = '/pricing';
          });
        } else {
          this.error = err?.error?.message
                    ?? 'Failed to send invite. Please check the details and try again.';
        }
        this.loading = false;
      }
    });
  }

  copyPassword(): void {
    if (!this.success?.temporaryPassword) return;
    navigator.clipboard.writeText(this.success.temporaryPassword).then(() => {
      this.copied = true;
      setTimeout(() => (this.copied = false), 2000);
    });
  }

  resetSuccess(): void {
    this.success = null;
    this.copied  = false;
  }
}